<script>
import countlyVue from '../../compat/vue-core';

export default countlyVue.components.BaseComponent.extend({
  name: 'ClyInputDropdownTrigger',
  props: {
    focused: { type: Boolean, default: false },
    opened: { type: Boolean, default: false },
    arrow: { type: Boolean, default: true },
    selectedOptions: {
      type: [Array, Object, String],
      default() {
        return {};
      },
    },
    placeholder: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    adaptiveLength: { type: Boolean, default: false },
  },
  computed: {
    iconClass() {
      return (this.opened ? 'ion-arrow-up-b is-reverse' : 'ion-arrow-up-b');
    },
    description() {
      if (Array.isArray(this.selectedOptions)) {
        return this.selectedOptions.map((option) => option.label).join(', ');
      }
      if (typeof this.selectedOptions === 'string') {
        return this.selectedOptions;
      }
      return this.selectedOptions.label;
    },
    componentName() {
      if (this.adaptiveLength) {
        return 'el-pseudo-input';
      }
      return 'el-input';
    },
    classes() {
      const classes = {
        'is-focus': this.focused,
        'is-disabled': this.disabled,
        'is-adaptive': this.adaptiveLength,
        'is-arrow': this.arrow,
      };

      return classes;
    },
  },
  methods: {
    focus() {
      this.$refs.elInput.focus();
    },
  },
});
</script>
<template>
  <component
    :is="componentName"
    ref="elInput"
    v-bind="$attrs"
    v-model="description"
    :class="classes"
    readonly="readonly"
    :placeholder="placeholder"
  >
    <template #prefix="scope">
      <slot
        name="prefix"
        v-bind="scope"
      />
    </template>
    <template
      v-if="arrow || !!$scopedSlots.suffix"
      slot="suffix"
    >
      <slot
        name="suffix"
        v-bind="selectedOptions"
      />
      <i
        class="el-select__caret"
        :class="[iconClass]"
      />
    </template>
  </component>
</template>
